import { SVGProps, Ref, forwardRef } from 'react';

export const VideocameraFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m14.775 12.5-1.91-1.134a5.7 5.7 0 0 1-.39 1.396C11.756 14.389 10.238 15 7.525 15H5.474C1.368 15 0 13.6 0 9.4V6.6C0 2.4 1.368 1 5.474 1h2.052c2.713 0 4.231.611 4.948 2.238q.265.601.391 1.396l1.91-1.134H16v9z"
                fill="currentColor"
            />
        </g>
    </svg>
));
VideocameraFilledSize16Glyph.displayName = 'VideocameraFilledSize16Glyph';
